module.exports = __webpack_public_path__ + "static/sonia_after-f363bf6748527db23b4a2d00efdb8589.png";